import React from 'react';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import FamilyBannerImage from './family-banner.png';


function FamilyBanner() {
    return (
        <Container>
            <Row>
                <Col xs={12} md={{ span: 10, offset: 1 }} lg={{ span: 10, offset: 1 }} xl={{ span: 8, offset: 2 }}>
                    <div className="display-flex flex-direction-column">
                        <Image src={FamilyBannerImage} alt="Family Banner" fluid />
                        <hr className="main-divider" />
                    </div>
                </Col>
            </Row>
        </Container>
    )
}

export default FamilyBanner;
